export const maso_details = [
    {id: 1, text: "Status", value: "Owned"},
    {id: 2, text: "DOB", value:"2021-07-05"},
    {id: 3, text: "AKC", value:"SS28349105"},
    {id: 4, text: "Advanced Cardiac", value:"NORMAL AUSC+ECHO LR-ACA4362/24M-VPI"},
    {id: 5, text: "OFA Hips", value:"EXCELLENT LR-270215E24M-P-VPI"},
    {id: 6, text: "Elbows", value:"NORMAL LR-EL117482M24-P-VPI"},
    {id: 7, text: "Eyes", value:"Cleared Yearly"},
    {id: 8, text: "Genotype", value:"B/y"},
];